import axios from "../../axios";
const url = "/user/operations/educational-consultant";

const state = {
  list: [],
  allTaxonomies: [],
  menuFIlterLibraryDictionary: [],
  menuFIlterBlock: [],
};

const actions = {
  async getList({ commit }, payload) {
    const response = await axios.get(url, { params: payload });
    if (response.status === 200) {
      commit("SET_LIST", response.data.data);
    }
    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async changeOrder({ commit }, payload) {
    const response = await axios.post(url + "/change-order", payload);
    return response;
  },
};

const mutations = {
  SET_LIST(state, data) {
    state.list = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
